import React from 'react'
import ReactSVG from 'react-svg'

import add from './add.svg'
import addPrimary from './add-primary.svg'
import trashcan from './trashcan.svg'
import trashcanPrimary from './trashcan-primary.svg'
import chevronDown from './chevron-down.svg'
import chevronDownPrimary from './chevron-down-primary.svg'
import calendar from './calendar.svg';
import edit from './edit.svg';

const Svg = (props) => <ReactSVG {...props}
  wrapper={'div'}
  beforeInjection={(svg,) => {
    if(props.style && props.style.width) svg.setAttribute('style', 'width: ' + props.style.width + 'px')
    if(props.style && props.style.height) svg.setAttribute('style', 'height: ' + props.style.height + 'px')
  }}
  afterInjection={(err,svg) => {
    if(err) console.error(err)
  }}
/>

export const SvgAdd = (props) => <Svg src={add} {...props} />
export const SvgAddPrimaryBrand = (props) => <Svg src={addPrimary} {...props} />
export const SvgCalendar = (props) => <Svg src={calendar} {...props} />
export const SvgChevronDown = (props) => <Svg src={chevronDown} {...props} />
export const SvgChevronDownPrimary = (props) => <Svg src={chevronDownPrimary} {...props} />
export const SvgEdit = (props) => <Svg src={edit} {...props} />
export const SvgTrashcan = (props) => <Svg src={trashcan} {...props} />
export const SvgTrashcanPrimaryBrand = (props) => <Svg src={trashcanPrimary} {...props} />
